import { apiBaseUrl } from 'app/src/msw/commonconfig'
import { mockPortalConfig } from 'app/src/msw/stories/portalconfig-stories-mock'
import { portalConfigurationApi } from 'app/src/services/welfareportal'
import { http, HttpResponse, type DefaultBodyType } from 'msw'

const getPortalConfig = http.get<object, DefaultBodyType, portalConfigurationApi.PortalConfig>(
  apiBaseUrl + '/portalconfiguration',
  () => HttpResponse.json(mockPortalConfig),
)

export const portalConfigHandlers = [getPortalConfig]
